export const IvansLobOptions = Object.freeze([
    { displayValue: 'Select Line of Business', value: '0', id: null, policyKind: null },
    { displayValue: 'Personal Auto', value: '1', id: 'PEAK', policyKind: 'Auto' },
    { displayValue: 'Commercial', value: '2', id: 'COMMERCIAL', policyKind: null },
    { displayValue: 'Motorcycle/Off-Road', value: '3', id: 'PEAK', policyKind: 'Cycle' },
    { displayValue: 'Homeowners', value: '4', id: 'Homeowners', policyKind: null },
    { displayValue: 'Umbrella', value: '5', id: 'Umbrella', policyKind: null },
    { displayValue: 'RV', value: '6', id: 'PEAK', policyKind: 'RV' },
    { displayValue: 'Boat', value: '7', id: 'PEAK', policyKind: 'Boat' }
]);
